import React, {useCallback, useEffect, useState} from 'react';
import TextBox from '../components/textbox'
import ButtonComp from '../components/button'
import '../styling/containerStyles.css'
import DropDown from '../components/dropDown'
import Label from '../components/label'
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import WarningModal from '../components/modal'

interface CustomerDetailsProps{
    division: string;
    handleToUpdateAdded:Function;
}

export const CustomerDetails: React.FC<CustomerDetailsProps> = (props: CustomerDetailsProps) =>{

    const{
        division, handleToUpdateAdded
    } = props;

    const [name, setName] = useState('')
    const [alternatePhone, setAlternatePhone] = useState('')
    const [profession, setProfession] = useState('Choose')
    const [pincode, setPincode] = useState('')
    const [message, setMessage] = useState('')
    const [locationBlocked, setLocationBlocked] = useState(false);
    const [isPinDisabled, setIsPinDisabled] = useState(true);

    useEffect(() => {  
        const storedDealerInfo = localStorage.getItem('dealer_info');
        const dealerData = storedDealerInfo && JSON.parse(storedDealerInfo);
        if(dealerData?.dealerpin_c) {
            setPincode(dealerData.dealerpin_c);
        }

        if(navigator.permissions) {
            navigator.permissions.query({name: 'geolocation'})
                .then(res => {
                    if(res.state === 'denied' || !dealerData?.dealerpin_c) {
                        setIsPinDisabled(false);
                    }
                })
        }        
    }, []);
    
    const handleToUpdateContent = (name:string, arg: string) => {
        if(name === 'name') {
            setName(arg)
        }
        if(name === 'alternatePhone') {
            setAlternatePhone(arg)
        }
        if(name === 'pincode') {
            const newValue = arg?.replace(/\D/g, "")?.substring(0, 6);
            setPincode(newValue);
        }
    }
    
    const handleToUpdateProfession = (arg: string) => {
        setProfession(arg)
    }
    

    const handleToUpdateAdd = (arg: string) => {
        var regexPhone = /^[0-9]{10}$/;
        const data = {
            "name": name,
            "alternatePhone": alternatePhone,
            "profession": profession,
            "pincode": pincode
        }
        if(name.length === 0){
            setMessage('Please enter a valid name')
            setName('')
        }
        else if(alternatePhone.length !== 0 && regexPhone.test(alternatePhone) === false){
            setMessage('Please enter a valid alternate phone number')
            // setAlternatePhone('')
        }
        else if(profession === 'Choose'){
            setMessage('Please choose a valid profession ')
            setProfession('')
        }
        else if(pincode.length !== 6){
            setMessage('Invalid Pincode')
            setPincode('')
        }
        else
            handleToUpdateAdded(data)
        
    }

    const heading = "Location Disabled !!"
    const content = "Please allow location permissions to continue"
    
    const getLocn = () => {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                var geocoder = new google.maps.Geocoder();
                var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                geocoder.geocode({ 'location': latlng }, 
                    (results, status) => {
                        if (status === google.maps.GeocoderStatus.OK && results[0]) {
                            for (var j = 0; j < results[0].address_components.length; j++) {
                                if (results[0].address_components[j].types[0] === 'postal_code') {
                                    setPincode(results[0].address_components[j].long_name)
                                }
                            }
                            // var address = results[0].formatted_address.split(',')
                            // address = address[address.length-2].split(' ')
                            // setPincode(address[address.length - 1])
                        }
                })
            },
            (err) => {
                setLocationBlocked(true);
                setIsPinDisabled(false);
            }
        )       
    }

    const handleClose = useCallback(() => {
        setLocationBlocked(false);
    }, [locationBlocked]);
    
        let dropDownItems = [];
        if(division === 'FCC')
            dropDownItems = ['Select', 'Contractor', 'Carpenter', 'Polisher']
        else
            dropDownItems = ['Select', 'Waterproofer', 'Kothi contractor', 'Painting Contractor', 'Plumbing Contractor', 'Mason', 'Painter', 'Others']
        return (
            <div className='custDetails' >
                    {
                        locationBlocked && <WarningModal heading={heading} content={content} isOpen={locationBlocked} handleClose={handleClose}/>
                    }
                    <div className='buttonAndLabel'>
                        <Button className='goBack' onClick={() => {handleToUpdateAdded('GoBack')}} ><ArrowBackIosIcon /></Button> 
                        <Label content='Account Details' />
                    </div>
                    <br></br>
                    <TextBox className='textBox custom_input'
                                label={'Name'} 
                                state={'name'}
                                placeholder={'Input your name'} 
                                handleToUpdate={handleToUpdateContent} />
                    <TextBox className='textBox custom_input'
                                label={'Alternate Phone'} 
                                state={'alternatePhone'}
                                placeholder={'Input alternate phone number'} 
                                handleToUpdate={handleToUpdateContent} />
                    <DropDown item={dropDownItems} 
                            name='profession'
                            label='Profession' 
                            handleToUpdate={handleToUpdateProfession}/>

                    <div className='pincodeBox'>
                        <div className='box1'>
                            <TextBox className='textBox custom_input'
                                        label={'Pin Code'} 
                                        state={'pincode'}
                                        placeholder={'Eg: 560042'}
                                        defaultValue={pincode} 
                                        handleToUpdate={handleToUpdateContent}
                                        disabled={isPinDisabled} 
                            />    
                        </div>
                        <div className='box2'>
                            <IconButton 
                                disabled={false}
                                onClick={getLocn}
                            >
                                <GpsFixedIcon />
                            </IconButton>
                        </div>
                    </div>

                    <div className='message'>{message}</div>
                    
                    <ButtonComp label= {'Pin Code'} 
                            name={'ADD'} 
                            visible={true}
                            handleToUpdate={handleToUpdateAdd}  />
                
                
            </div>             
        )
    }


export default CustomerDetails